import React from 'react';

import {Helmet} from 'views/module';

import NewClientLeadScene from 'views/scenes/client_lead/new/NewClientLead';

const ClientLeadNew = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Home</title>
      </Helmet>
      <NewClientLeadScene
      />
    </>
  );
};

export default ClientLeadNew;
